module.exports = __webpack_public_path__ + "assets/images/f9f331710d88ac2008e9a52777edf8dc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/portfolio/amex-mpj/amex-mpj-0.jpg
// module id = 797
// module chunks = 0